import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

const SIZES = {
  xs: 'h-5 w-5 text-[8px]',
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-16 w-16 text-xl',
};

export function UserAvatar({ user, email, name, image, size = 'md', className = '' }) {
  const displayName = user?.name || name || user?.email || email || '?';
  const displayImage = user?.profile_image || image;
  const initials = displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  const dims = SIZES[size] || SIZES.md;

  return (
    <Avatar className={`${dims} ${className}`} data-testid="user-avatar">
      {displayImage && <AvatarImage src={displayImage} alt={displayName} />}
      <AvatarFallback className="bg-[#F05A28] text-white font-semibold">{initials}</AvatarFallback>
    </Avatar>
  );
}
